var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalInfoHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2508 7.20078C8.01403 7.20078 6.20078 9.01403 6.20078 11.2508C6.20078 13.4875 8.01403 15.3008 10.2508 15.3008C12.4875 15.3008 14.3008 13.4875 14.3008 11.2508C14.3008 9.01403 12.4875 7.20078 10.2508 7.20078ZM5.30078 11.2508C5.30078 8.51697 7.51697 6.30078 10.2508 6.30078C12.9846 6.30078 15.2008 8.51697 15.2008 11.2508C15.2008 13.9846 12.9846 16.2008 10.2508 16.2008C7.51697 16.2008 5.30078 13.9846 5.30078 11.2508Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2008 26.2008H0.300781V25.7508C0.300781 23.583 1.2602 21.6171 2.81514 20.1335C4.64446 18.3882 7.30461 17.3008 10.2508 17.3008C11.7486 17.3008 13.1713 17.5817 14.4483 18.0865C17.8093 19.4151 20.2008 22.3209 20.2008 25.7508V26.2008ZM10.2508 18.2008C7.52217 18.2008 5.08859 19.2084 3.43642 20.7847C2.14698 22.015 1.33767 23.5857 1.21662 25.3008H19.2849C19.0873 22.5101 17.0606 20.0869 14.1174 18.9235C12.9465 18.4606 11.6361 18.2008 10.2508 18.2008Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0831 20.3706C11.0831 20.8299 10.7108 21.2022 10.2515 21.2022C9.79223 21.2022 9.41992 20.8299 9.41992 20.3706C9.41992 19.9114 9.79223 19.5391 10.2515 19.5391C10.7108 19.5391 11.0831 19.9114 11.0831 20.3706Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0831 23.1324C11.0831 23.5916 10.7108 23.9639 10.2515 23.9639C9.79223 23.9639 9.41992 23.5916 9.41992 23.1324C9.41992 22.6731 9.79223 22.3008 10.2515 22.3008C10.7108 22.3008 11.0831 22.6731 11.0831 23.1324Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9004 6.39961V5.59961H27.1004V6.39961H17.9004Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1004 8.59961V9.39961L19.9004 9.39961V8.59961L27.1004 8.59961Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9004 12.3996V11.5996H27.1004V12.3996H17.9004Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9004 15.3996V14.5996L27.1004 14.5996V15.3996L20.9004 15.3996Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfoHover);
export default __webpack_public_path__ + "static/media/personal-info-hover.a9a6af5b.svg";
export { ForwardRef as ReactComponent };